var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Detil Pengajuan tes"
    }
  }, [(!_vm.DataHeader || !_vm.listdokap) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.DataHeader && _vm.listdokap) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Data Pengajuan Izin"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v(_vm._s(_vm.DataHeader.URAIAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.npwp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.NM_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.AL_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No HP/Telepon")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_hp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Jenis Permohonan Izin")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.nama_ijin))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.ur_status))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("No Setuju")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_setuju))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tgl Setuju")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_setuju))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Kantor")]), _vm._v(" "), _c('td', [_vm._v("020400 - KPU BC Tipe B Batam")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Tanggal Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_mohon))])])])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n                  Lampiran Dokumen\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokap), function(dokap) {
    return _c('tr', {
      key: dokap.id_permohonan_dokap
    }, [_c('td', [_vm._v(_vm._s(dokap.nama_dokap))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokap.keterangan))]), _vm._v(" "), _c('td', [(dokap.kd_dokap === 151) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]) : _vm._e(), _vm._v(" "), (dokap.url_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "href": dokap.url_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokapptg), function(dokapptg) {
    return _c('tr', {
      key: dokapptg.id_permohonan_dokap
    }, [_c('td', [_vm._v(_vm._s(dokapptg.nama_dokap))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokapptg.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokapptg.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-md-block"
    }, [_vm._v(_vm._s(dokapptg.keterangan))]), _vm._v(" "), _c('td', [(dokapptg.nm_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": _vm.$http.options.base + dokapptg.url_file + '/' + dokapptg.nm_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), (dokapptg.fl_mandatory === null) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Dokumen/Data Pelengkap"
      },
      on: {
        "click": function($event) {
          _vm.confir(dokapptg.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/browseftz'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" Back\n            ")])], 1)])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Detail Dokumen Pelengkap",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl),
      callback: function($$v) {
        _vm.Modaleditdtl = $$v
      },
      expression: "Modaleditdtl"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "500px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor Peti Kemas")]), _vm._v(" "), _c('th', [_vm._v("Ukuran")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', {
      key: peti.isian1
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))])])
  }))])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01e6b45a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Brows/DetilBrowsFtz.vue
// module id = 318
// module chunks = 0